import { CloseRequestPayload } from "appworks/model/gameplay/requests/close-request-payload";
import { commsManager } from "appworks/server/comms-manager";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";

export function CloseCommand(): Contract<void> {
    return new Parallel<void>([
        () => commsManager.request(new CloseRequestPayload()),
        () => Services.autoplay.updateWinLoss()
    ]);
}
